import React from "react";
import coverimage from "../image/Knee cover page.png";
import logo from "../image/logo.png";

const Cover = () => {
  // Define styles as a string
  const styles = `
    /* Landing Page Container */
    .landing-page {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 89vw;
      min-height: 100vh;
      background: linear-gradient(135deg,#fff, #f5f7fa, #5e8fde);
      padding: 0 5%;
    }

   
      /* Left Section */
    .left-section {
      display: flex;
      flex-direction: column;
      justify-content: center; /* Center content vertically */
      align-items:center; /* Align content to the left */
      width: 50vw;
      min-height: 100vh;
    }

    .left-section h2 {
      font-size: 3.5vh;
      color: #666;
    }

    .left-section h1 {
      font-size: 10vh;
      font-weight: bold;
      color: #3e2465;
    }

    .left-section h3 {
      font-size: 5vh;
      font-weight: bold;
      color: #3e2465;
      margin-bottom: 1vh;
      margin-top:-5vh;
    }

    .left-section p {
      font-size: 1rem;
      color: #777;
      margin-bottom: 2rem;
    }

    .left-section img {
      width: 30%;
    }

    /* Right Section */
    .right-section {
      width: 50vw;
      position: relative;
      padding-left: 20vw;
      padding-bottom: 3vh;
    }

    .phone {
      background-size: cover;
      border-radius: 30px;
      width: 18vw;
      height: auto;
      padding: 10px;
      position: relative;
    }

    .phone img {
      width: 80%;
      border-radius: 30px;
    }

    .continue-btn {
      background-color: #6c63ff;
      color: white;
      border: none;
      padding: 10px 20px;
      border-radius: 30px;
      cursor: pointer;
      margin-top: 20px;
    }

    .container {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    /* Styling for the background circles */
    .circle {
      position: absolute;
      border-radius: 50%;
    }

  .circle1 {
      width: 20vh;
      height: 20vh;
      background-color: #5e8fde; /* Main blue matching the background */
      top: -10%;
      left: -20%;
    }

.circle2 {
  width: 36vh;
  height: 36vh;
  background-color: rgba(208, 231, 255, 0.2); /* Light blue with 70% opacity */
  bottom: -5%;
  right: -20%;
}


    .circle3 {
      width: 5vh;
      height: 5vh;
      background-color: #4a90e2; /* Lighter blue */
      bottom: 80%;
      right: -20%;
    }

    .circle4 {
      width: 3vh;
      height: 3vh;
      background-color: #9bbffb; /* Very light blue */
      top: 65%;
      left: -20%;
    }

    .main-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      z-index: 1; /* Ensure main content is above the circles */
    }

    /* Media Queries */
    @media (max-width: 768px) {
      .right-section {
        width: 0vw;
        display: none;
      }
      .left-section {
        align-items: center;
        justify-content: center;
        width: 100vw;
        min-height: 100vh;
        padding-bottom: 3vh;
        margin-left: 0; /* Remove left margin */
        text-align: center; /* Center text for small screens */
      }
      .left-section h1 {
      font-size: 15vw;
      font-weight: bold;
      color: #3e2465;
    }

    .left-section h3 {
      font-size: 10vw;
      font-weight: bold;
      color: #3e2465;
      margin-bottom: 1vh;
      margin-top:-0.5vh;
    }
    }
  `;

  return (
    <>
      <style>{styles}</style>
      <div className="landing-page" id="home">
        <div className="left-section">
          <h1>
            Physio-Mize <br />
          </h1>
          <h3>Physiotherapy Optimized</h3>
          <p>
            Physio-Mize is an innovative remote physiotherapy solution that
            utilizes wearable technology to provide real-time joint angle
            measurements and pain localization, enhancing patient-therapist
            communication. Its affordable, user-friendly design empowers
            patients to engage actively in their rehabilitation from home,
            bridging healthcare access gaps.
          </p>
        </div>
        <div className="right-section">
          <div className="phone">
            <div className="container">
              <div className="circle circle1"></div>
              <div className="circle circle2"></div>
              <div className="circle circle3"></div>
              <div className="circle circle4"></div>
              <div className="main-content">
                <div className="image-container">
                  <img src={coverimage} alt="phone" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cover;
